import { IRecurringTaskPayload } from '../pmd/pages/tasks/types'
  import servicesConfig, { CustomAxiosHeaders } from '../config/services'
  
  import { requests } from '.'
  
  // use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
  const serviceName = 'RecurringTaskService'
  const host = servicesConfig.Locations
  const opts: CustomAxiosHeaders = { host, serviceName }
  const request = (addlOpts?: CustomAxiosHeaders) => {
    return requests(Object.assign({}, opts, addlOpts))
  }
  
  const RecurringTaskService = {
    create: (locationId: string, payload: IRecurringTaskPayload) =>
      request().post(
        `${locationId}/recurring-tasks`,
        payload
      ),
    
    getRecurringTasksInLocation: (locationId: string) =>
      request().get<IRecurringTaskPayload[]>(`${locationId}/recurring-tasks`),
    
    getRecurringTasksByIds: (locationId: string, payload) =>
      request().post(`${locationId}/recurring-tasks/ids`, payload),

    update: (locationId: string, taskId: string, payload: IRecurringTaskPayload) =>
      request().put(`${locationId}/recurring-tasks/${taskId}`, payload),

    delete: (locationId: string, taskId: string) =>
      request().delete(`${locationId}/recurring-tasks/${taskId}`),

    bulkDelete: (locationId: string, payload) => {
      return request().delete(`${locationId}/recurring-tasks/bulk/ids`, {
        data: payload
      })
    }
  }
  
  export default RecurringTaskService
  